import { render, staticRenderFns } from "./TableFooterRuleCheckStatusContainer.vue?vue&type=template&id=8f2cc822&scoped=true&"
import script from "./TableFooterRuleCheckStatusContainer.vue?vue&type=script&lang=ts&"
export * from "./TableFooterRuleCheckStatusContainer.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f2cc822",
  null
  
)

export default component.exports